import type { StaticUserAssignment } from "@msuite/utils/types";

/** Props Interface */
interface CommandPlanUserAssignmentProps {
	userAssignment: StaticUserAssignment;
}

export function CommandPlanUserAssignment({ userAssignment }: CommandPlanUserAssignmentProps) {
	return (
		<div className="card">
			<p>{userAssignment.name}</p>
		</div>
	);
}
